// extracted by mini-css-extract-plugin
export default {"toggleSwitch":"ToggleSwitch_toggleSwitch__fDS+7","thumb":"ToggleSwitch_thumb__n+nMt","on":"ToggleSwitch_on__Q+jbs"};